<template>
  <SysDialogFullscreen v-model="dialog_ativo_computed">
    <template #titulo>
      <DialogConfirmarCancelamento :parametros="parametros" @click:btn-principa="fecharDialog">
        <template #ativador="{ callback }">
          <v-btn icon class="ml-n2 mr-5" dark @click="callback">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </DialogConfirmarCancelamento>

      Ajuste de Pedido

      <v-spacer />

      <span class="font-16 mr-4">
        <span class="font-weight-medium">Carrinho de Compra: </span>
        <span class="font-weight-regular">#{{ idpedido }} - {{ descricao_fornecedor }}</span>
      </span>
    </template>

    <div class="d-flex pl-4 pr-8 overflow-y-hidden">
      <div class="col-4 pr-5">
        <Ajustar
          :parametros="parametros"
          :produtos="produtos"
          :fornecedores="fornecedores"
          :descricao_fornecedor="descricao_fornecedor"
          :valores_resumo_detalhado="valores_resumo_detalhado"
          @ajustar="ajustarValor"
        />
      </div>

      <div class="col-8 pr-0">
        <EntendaOQueMudou
          :parametros="parametros"
          :produtos="produtos"
          :pesquisa="pesquisa"
          @click:filtar-por-acao="ev => pesquisa = ev.pesquisa"
          @obter:resumo-ajustes-computed="ev => obterResumoAjusteComputed(ev)"
        />

        <v-divider class="mt-5" style="background-color: #7C7C83" />

        <Tabela
          :pesquisa="pesquisa"
          :produtos="produtos"
          :filial_pedido="filial_pedido"
          @update:pesquisa="ev => pesquisa = ev"
          @update:produtos="ev => produtos = ev"
        >
          <template #top.right>
            <div class="ml-3">
              <DialogConfirmarCancelamento :parametros="parametros" @click:btn-principa="fecharDialog" />

              <Dialog
                titulo="Aplicar Ajustes no Carrinho"
                texto_btn_secundario="Cancelar"
                texto_btn_principal="Aplicar"
                :largura="500"
                @click:btn-principal="aplicarCarrinho"
              >
                <span style="font-size: 14px">Os ajustes foram feitos! Para finalizar e aplicar as alterações no carrinho compras, você precisa confirmar. Deseja continuar?</span>

                <div class="pt-3">
                  <v-textarea
                    class="justificativa"
                    v-model="parametros.justificativa"
                    label="Insira a justificativa obrigatória"
                    placeholder="O fornecedor exige que o pedido de tubos contenha 200m e seja que 40% do valor sejam de Conexões."
                    :error-messages="justificativaErrors"
                    outlined
                    hide-details="auto"
                    autocomplete="off"
                    dense
                  />
                </div>

                <template #ativador="{ callback }">
                  <v-btn
                    class="text-transform-none font-weight-regular ml-3"
                    dark
                    color="#013254"
                    @click="callback"
                  >
                    Aplicar no Carrinho
                  </v-btn>
                </template>
              </Dialog>
            </div>
          </template>
        </Tabela>
      </div>
    </div>
  </SysDialogFullscreen>
</template>

<script>
import SysDialogFullscreen from "@/components/padraoDeLayout/SysDialogFullScreen.vue";
import Ajustar from "@/components/compra/ProdutosGerais/Carrinho/Meta/Ajustar/Index.vue";
import EntendaOQueMudou from "@/components/compra/ProdutosGerais/Carrinho/Meta/EntendaOQueMudou/Index.vue";
import api from "@/api/api";
import {logout} from "@/helpers";
import Tabela from "@/components/compra/ProdutosGerais/Carrinho/Meta/Tabela.vue";
import Dialog from "@/components/compra/ProdutosGerais/Carrinho/Meta/Dialog.vue";
import {coberturaFuturaEmDias, getAcao} from "@/components/compra/ProdutosGerais/Carrinho/Meta/utils";
import DialogConfirmarCancelamento from "@/components/compra/ProdutosGerais/Carrinho/Meta/DialogConfirmarCancelamento.vue";
import {required} from "vuelidate/lib/validators";

export default {
  name: "PedidoConfirmeMeta",
  components: {
    DialogConfirmarCancelamento,
    Dialog,
    Tabela,
    Ajustar,
    SysDialogFullscreen,
    EntendaOQueMudou,
  },
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  emits: ["update:modelValue"],
  props: {
    modelValue: Boolean,
    idprodutos: {
      type: Array,
      required: true
    },
    idpedido: {
      type: Number,
      required: false
    },
    filial_pedido: {
      type: Number,
      required: false
    },
    fornecedores: {
      type: Array,
      default: () => [],
    },
    descricao_fornecedor: {
      type: String,
      required: true
    },
    filtros_gerais_inicial: null,
  },
  data: () => ({
    parametros: {
      tipo_ajuste: 'POR_VALOR',
      valor_desejado: 0,
      unidade_medida: {
        id: null,
        descricao: '',
      },
      remover_produtos_com_un_medida_diferente: true,
      alterar_mix: true,
      segmentos: [],
      justificativa: '',
      filtros_gerais: {
        primeira_entrada: [],
        ultima_entrada: [],
        idade: [],
        curva_popularidade: [],
        curva_rentabilidade: [],
        curva_criticidade: [],
        compradores: [],
        segmentos: [],
        secoes: [],
        categorias: [],
        status_produto: [],
        linhas: [],
        pedidos_pendentes: [],
        histogramas: [],
        produtos: [],
      },
    },
    produtos: [],
    pesquisa: '',
    valores_resumo_detalhado: {},
  }),
  validations: {
    parametros: {
      justificativa: {
        required
      }
    }
  },
  computed: {
    dialog_ativo_computed: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        this.$emit('update:modelValue', valor);
      }
    },
    justificativaErrors() {
      const errors = [];
      if (!this.$v.parametros.justificativa.$dirty) return errors;
      !this.$v.parametros.justificativa.required && errors.push("Campo Obrigatório.");
      return errors;
    },
  },
  watch: {
    dialog_ativo_computed() {
      if (!this.dialog_ativo_computed) return;

      this.buscarPedido();
      this.setarFiltrosIniciais();
    },
  },
  methods: {
    setarFiltrosIniciais() {
      if (!this.filtros_gerais_inicial) return;

      Object.keys(this.filtros_gerais_inicial).forEach(key => {
        this.parametros.filtros_gerais[key] = this.filtros_gerais_inicial[key];
      })
    },
    adicionarAcao(produtos) {
      return produtos.map(item => ({
        ...item,
        cobertura_futura_antes: coberturaFuturaEmDias({
          consumo_medio_mensal: item.consumo_medio_mensal,
          sugestao: item.qtd_inicial,
          estoque_futuro_tempo_ressuprimento: item.estoque_futuro_tempo_ressuprimento,
        }),
        cobertura_futura_depois: coberturaFuturaEmDias({
          consumo_medio_mensal: item.consumo_medio_mensal,
          sugestao: item.qtd_ajustada,
          estoque_futuro_tempo_ressuprimento: item.estoque_futuro_tempo_ressuprimento,
        }),
        acao: getAcao(item),
      }));
    },
    buscarPedido() {
      const body = {
        idpedido: this.idpedido,
        idprodutos: this.idprodutos,
      };

      api.post('/compras/produtos/carrinho/ajuste-pedido/buscar-produtos', body)
        .then((response) => this.produtos = this.adicionarAcao(response.data.produtos))
        .catch(logout);
    },
    ajustarValor() {
      if (!Number(this.parametros.valor_desejado) > 0) {
        alert('Informe o valor desejado para o ajuste.');
        return;
      }

      if (this.parametros.tipo_ajuste === 'POR_UNIDADE_MEDIDA' && String(this.parametros.unidade_medida.id || '').length === 0) {
        alert('Informe a un. medida desejada.');
        return;
      }

      const segmentos = this.parametros.segmentos.filter(item => Number(item.percentual_ajustado) > 0);

      const soma_percentuais = segmentos.reduce((a, b) => a + Number(b.percentual_ajustado || 0), 0);

      if (soma_percentuais > 0 && soma_percentuais < 100) {
        alert('A soma dos percentuais devem totalizar 100% na proporção por segmento.');
        return;
      }

      const body = {
        idpedido: this.idpedido,
        tipo_ajuste: this.parametros.tipo_ajuste,
        valor_desejado: this.parametros.valor_desejado,
        unidade_medida: this.parametros.unidade_medida.id,
        remover_produtos_com_un_medida_diferente: this.parametros.remover_produtos_com_un_medida_diferente,
        alterar_mix: this.parametros.alterar_mix,
        segmentos: segmentos.map(item => ({
          id: item.id,
          valor_desejado: (Number(this.parametros.valor_desejado) / 100.0) * Number(item.percentual_ajustado),
        })),
        produtos: this.produtos.filter(item => item.qtd_inicial > 0).map(item => ({
          ...item,
          qtd_ajustada: item.qtd_inicial,
        })),
        filtros: this.parametros.filtros_gerais,
      };

      api.post('/compras/produtos/carrinho/ajuste-pedido/ajustar-valor', body)
        .then((response) => {
          this.produtos = this.adicionarAcao(response.data.produtos)
        })
        // .catch(logout);
    },
    aplicarCarrinho() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      if (!Number(this.parametros.valor_desejado) > 0) {
        alert('Informe o valor desejado para o ajuste.');
        return;
      }

      if (String(this.parametros.justificativa || '').length === 0) {
        alert('Insira a justificativa obrigatória.');
        return;
      }

      const body = {
        produtos: this.produtos.filter(item => Number(item.qtd_ajustada) > 0),
        idpedido: this.idpedido,
        justificativa: this.parametros.justificativa,
      };

      api.post('/compras/produtos/carrinho/ajuste-pedido/aplicar-carrinho', body)
        .then(() => {
          this.$emit('atualizar-pedido');
          this.fecharDialog();

          this.$v.$reset();
          this.$nextTick(() => {
            this.parametros.justificativa = '';
            this.$v.$reset();
          });
        })
        .catch(logout);
    },
    fecharDialog() {
      this.dialog_ativo_computed = false;
      this.resetarStates();
    },
    resetarStates() {
      this.parametros.tipo_ajuste = 'POR_VALOR';
      this.parametros.valor_desejado = 0;
      this.parametros.unidade_medida = {
        id: null,
        descricao: '',
      };
      this.parametros.remover_produtos_com_un_medida_diferente = true;
      this.parametros.alterar_mix = true;
      this.parametros.segmentos = [];
      this.produtos = [];
      this.pesquisa = '';
    },
    obterResumoAjusteComputed(item) {
      this.valores_resumo_detalhado = item;
    }
  },
};
</script>

<style scoped>
.justificativa ::v-deep textarea::placeholder {
  font-size: 12px;
}
</style>
